import echarts from 'echarts'
const install = function (Vue) {
  Object.defineProperties(Vue.prototype, {
    $chart: {
      get () {
        return {
          line1: function (id, myData, nameData) {
            require('echarts/lib/chart/bar')
            require('echarts/lib/component/tooltip')
            require('echarts/lib/component/title')
            require('echarts/lib/component/legend')
            require('echarts/lib/component/grid')
            this.chart = echarts.init(document.getElementById(id))
            this.chart.clear()
            const optionData = {
              // title: {
              //   subtext: type
              // },
              tooltip: {
                trigger: 'axis',
                axisPointer: {
                  type: 'shadow'
                },
                textStyle: {
                  align: 'left'
                }
                // formatter (v) {
                //   return 'APP: ' + myData[v[0].dataIndex].appName + '<br>内容类别: ' + myData[v[0].dataIndex].contentTypeName + '<br>文章名称: ' + myData[v[0].dataIndex].contentTitle
                // }
              },
              grid: {
                width: 'auto',
                top: '5px',
                left: '75px',
                bottom: '10px'
              },
              xAxis: {
                show: false,
                type: 'value',
                axisLabel: {
                  interval: 0
                },
                textStyle: {
                  color: '#666',
                  fontSize: 10
                },
                axisTick: {
                  interval: 5,
                  length: 5
                }
              },
              yAxis: {
                type: 'category',
                textStyle: {
                  // color: '#666',
                  fontSize: 10
                },
                data: nameData,
                axisTick: {
                  show: false
                },
                axisLine: {
                  lineStyle: {
                    color: '#dddddd',
                    width: 1,
                    type: 'solid'
                  }
                },
                axisLabel: {
                  show: true,
                  color: '#767676',
                  fontSize: 10
                }
              },
              series: [{
                data: myData,
                type: 'bar',
                showBackground: true,
                backgroundStyle: {
                  color: 'rgba(220, 220, 220, 0.8)'
                },
                itemStyle: {
                  normal: {
                    color: '#4e5598',
                    label: {
                      show: true,
                      position: 'right',
                      textStyle: {
                        color: '#7a7a7a'
                        // fontSize: 16
                      }
                    }
                  }
                },
                barWidth: 12,
                zlevel: 1
              }]
            }
            this.chart.setOption(optionData)
          },
          line2: function (id, myData, nameData) {
            require('echarts/lib/chart/bar')
            // require('echarts/lib/component/tooltip')
            // require('echarts/lib/component/title')
            // require('echarts/lib/component/legend')
            // require('echarts/lib/component/grid')
            this.chart = echarts.init(document.getElementById(id))
            this.chart.clear()
            const optionData = {
              // title: {
              //   subtext: type
              // },
              tooltip: {
                trigger: 'axis',
                axisPointer: {
                  type: 'shadow'
                },
                textStyle: {
                  align: 'left'
                }
              },
              grid: {
                width: 'auto',
                top: '26px',
                left: '70px',
                bottom: '10px'
              },
              xAxis: {
                show: false,
                type: 'value',
                axisLabel: {
                  interval: 0
                },
                textStyle: {
                  color: '#666',
                  fontSize: 10
                },
                axisTick: {
                  interval: 5,
                  length: 5
                }
              },
              yAxis: {
                type: 'category',
                data: nameData,
                axisTick: {
                  show: false
                },
                axisLine: {
                  lineStyle: {
                    color: '#dddddd',
                    width: 1,
                    type: 'solid'
                  }
                },
                axisLabel: {
                  show: true,
                  color: '#767676',
                  fontSize: 10
                }
              },
              series: [{
                data: myData,
                type: 'bar',
                showBackground: true,
                backgroundStyle: {
                  color: 'rgba(220, 220, 220, 0.8)'
                },
                itemStyle: {
                  normal: {
                    color: '#4e5598',
                    label: {
                      show: true,
                      position: 'right',
                      textStyle: {
                        color: '#7a7a7a'
                        // fontSize: 16
                      }
                    }
                  }
                },
                barWidth: 12,
                zlevel: 1
              }]
            }
            this.chart.setOption(optionData)
          },
          line3: function (id, myData) {
            let data = []
            for (let i = 0; i < myData.length; i++) {
              let list = {
                value: myData[i].value,
                name: myData[i].name,
                itemStyle: myData[i].itemStyle
              }
              data.push(list)
            }
            require('echarts/src/chart/pie')
            // require('echarts/lib/component/tooltip')
            // require('echarts/lib/component/title')
            this.chart = echarts.init(document.getElementById(id))
            this.chart.clear()
            const optionData = {
              // title: {
              //   show: false
              // },
              tooltip: {
                trigger: 'item',
                // formatter: '{a} <br/>{b}: {c} ({d}%)'
                formatter: '{b}: {c} ({d}%)'
              },
              // legend: {
              //   orient: 'horizontal',
              //   x: 'center',
              //   y: 'bottom',
              //   itemWidth: 10,
              //   itemHeight: 10,
              //   icon: 'circle',
              //   data: ['已使用', '未使用', '未分配']
              // },
              series: [
                {
                  name: '预算比例',
                  type: 'pie',
                  radius: ['30%', '60%'],
                  center: ['50%', '50%'],
                  label: {
                    formatter (p) {
                      // let zb = '\n' + ((p.value / 5000000) * 100).toFixed(1) + '%'
                      // return (parseFloat(p.value).toFixed(0) + '').replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,') + zb
                      return p.value
                    },
                    show: true
                    // position: 'top'
                  },
                  itemStyle: { // 此配置
                    normal: {
                      borderWidth: 2,
                      borderColor: '#ffffff'
                    },
                    emphasis: {
                      borderWidth: 0,
                      shadowBlur: 10,
                      shadowOffsetX: 0,
                      shadowColor: 'rgba(0, 0, 0, 0.5)'
                    }
                  },
                  // label: {
                  //   show: false,
                  //   position: 'center'
                  // },
                  // emphasis: {
                  //   label: {
                  //     show: true,
                  //     fontSize: '12'
                  //   }
                  // },
                  // labelLine: {
                  //   show: false,
                  //   normal: {
                  //     length: 5,
                  //     position: 'inner'
                  //   }
                  // },
                  data: data
                  // data: [
                  //   {value: myData[0], name: nameData[0], itemStyle: {color: '#4e5598'}},
                  //   {value: myData[1], name: nameData[1], itemStyle: {color: '#b4b331'}},
                  //   {value: myData[2], name: nameData[2], itemStyle: {color: '#bda773'}},
                  //   {value: myData[3], name: nameData[3], itemStyle: {color: '#ecb535'}},
                  //   {value: myData[4], name: nameData[4], itemStyle: {color: '#d8664a'}},
                  //   {value: myData[5], name: nameData[5], itemStyle: {color: '#baa3c9'}}
                  // ]
                }
              ]
            }
            this.chart.setOption(optionData)
          },
          line4: function (id, legendData, xAxis, myData) {
            let data = []
            let number = 0
            let itemColor = [
              '#525CA3', '#BCBC26', '#CAAE7A', '#FBBA2B',
              '#F26550', '#C7A9D0', '#898655', '#6D5DA6', '#0F6DBB',
              '#664197', '#6B747B', '#3C5351', '#714F1A', '#8B2729'
            ]
            for (let i = 0; i < legendData.length; i++) {
              let list = {
                name: legendData[i],
                data: myData[i],
                type: 'bar',
                stack: '总量',
                itemStyle: {
                  color: itemColor[number]
                },
                barWidth: 12
              }
              number++
              if (!itemColor[number]) {
                number = 0
              }
              data.push(list)
            }
            require('echarts/lib/chart/bar')
            // require('echarts/lib/component/tooltip')
            // require('echarts/lib/component/title')
            // require('echarts/lib/component/legend')
            // require('echarts/lib/component/grid')
            this.chart = echarts.init(document.getElementById(id))
            this.chart.clear()
            const optionData = {
              // title: {
              //   subtext: type
              // },
              title: {
                text: 'Monthly New Content',
                textStyle: {
                  color: '#000',
                  fontSize: 14
                }
              },
              tooltip: {
                trigger: 'axis',
                axisPointer: {
                  type: 'shadow'
                },
                textStyle: {
                  align: 'left'
                }
                // trigger: 'plain',
                // backgroundColor: '#fff',
                // borderColor: '#333',
                // borderWidth: 1,
                // textStyle: {
                //   color: '#333'
                // },
                // formatter (v) {
                //   return 'APP: ' + myData[v[0].dataIndex].appName + '<br>内容类别: ' + myData[v[0].dataIndex].contentTypeName + '<br>文章名称: ' + myData[v[0].dataIndex].contentTitle
                // }
              },
              legend: {
                width: '100%',
                top: '24px',
                right: '10px',
                left: '8px',
                // x: 'right',
                // y: 'bottom',
                itemWidth: 10,
                itemHeight: 10,
                selectedMode: false,
                // icon: 'circle',
                data: legendData
              },
              grid: {
                width: 'auto',
                top: '100px',
                left: '10PX',
                right: '10PX',
                bottom: '30px'
              },
              xAxis: {
                type: 'category',
                data: xAxis,
                axisTick: {
                  show: false
                },
                axisLine: {
                  lineStyle: {
                    color: '#dddddd',
                    width: 1,
                    type: 'solid'
                  }
                },
                axisLabel: {
                  show: true,
                  color: '#767676',
                  fontSize: 10
                }
              },
              yAxis: {
                show: false,
                type: 'value',
                axisLabel: {
                  interval: 0
                },
                textStyle: {
                  color: '#666',
                  fontSize: 10
                },
                axisTick: {
                  interval: 5,
                  length: 5
                }
              },
              series: data
              // series: [
              //   {
              //     name: 'DBU',
              //     data: [3, 4, 20, 12, 2, 6, 76, 20, 12, 2, 6, 76],
              //     type: 'bar',
              //     stack: '总量',
              //     itemStyle: {
              //       color: '#4e5598'
              //     },
              //     barWidth: 20
              //   },
              //   {
              //     name: 'PC',
              //     data: [3, 4, 20, 12, 2, 6, 76, 20, 12, 2, 6, 76],
              //     type: 'bar',
              //     stack: '总量',
              //     itemStyle: {
              //       color: '#b4b331'
              //     },
              //     barWidth: 20
              //   },
              //   {
              //     name: 'CV&EP',
              //     data: [3, 4, 20, 12, 2, 6, 76, 20, 12, 2, 6, 76],
              //     type: 'bar',
              //     stack: '总量',
              //     itemStyle: {
              //       color: '#bda773'
              //     },
              //     barWidth: 20
              //   },
              //   {
              //     name: 'Medical',
              //     data: [3, 4, 20, 12, 2, 6, 76, 20, 12, 2, 6, 76],
              //     type: 'bar',
              //     stack: '总量',
              //     itemStyle: {
              //       color: '#ecb535'
              //     },
              //     barWidth: 20
              //   },
              //   {
              //     name: 'SC',
              //     data: [3, 4, 20, 12, 2, 6, 76, 20, 12, 2, 6, 76],
              //     type: 'bar',
              //     stack: '总量',
              //     itemStyle: {
              //       color: '#d8664a'
              //     },
              //     barWidth: 20
              //   },
              //   {
              //     name: 'Vaccine',
              //     data: [3, 4, 20, 12, 2, 6, 76, 20, 12, 2, 6, 76],
              //     type: 'bar',
              //     stack: '总量',
              //     itemStyle: {
              //       color: '#baa3c9'
              //     },
              //     barWidth: 20
              //   }
              // ]
            }
            this.chart.setOption(optionData)
          },
          line5: function (id, myData, internalNPS) {
            require('echarts/lib/chart/line')
            this.chart = echarts.init(document.getElementById(id))
            this.chart.clear()
            const optionData = {
              // title: {
              //   subtext: type
              // },
              title: [
                {
                  text: 'Internal NPS ',
                  left: 0,
                  textStyle: {
                    color: '#000',
                    fontWeight: 'normal',
                    fontSize: 14
                  }
                },
                {
                  text: internalNPS,
                  left: 100,
                  textStyle: {
                    color: '#525ca3',
                    fontSize: 16
                  }
                }
              ],
              // tooltip: {
              //   trigger: 'plain',
              //   backgroundColor: '#fff',
              //   borderColor: '#333',
              //   borderWidth: 1,
              //   textStyle: {
              //     color: '#333'
              //   },
              //   formatter (v) {
              //     return 'APP: ' + myData[v[0].dataIndex].appName + '<br>内容类别: ' + myData[v[0].dataIndex].contentTypeName + '<br>文章名称: ' + myData[v[0].dataIndex].contentTitle
              //   }
              // },
              legend: {
                top: '1%',
                right: '10px',
                // x: 'right',
                // y: 'bottom',
                // itemWidth: 10,
                // itemHeight: 10,
                // icon: 'circle',
                selectedMode: false,
                data: ['NPS(初版)', 'NPS(终版)']
              },
              grid: {
                width: '100%',
                top: '50px',
                left: '10PX',
                bottom: '30px'
                // bottom: '20%'
              },
              xAxis: {
                type: 'category',
                data: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
                axisTick: {
                  show: false
                },
                axisLabel: {
                  show: true,
                  color: '#767676',
                  fontSize: 10
                }
              },
              yAxis: {
                show: true,
                axisLine: {
                  show: false
                },
                axisTick: {
                  show: false
                },
                axisLabel: {
                  show: false
                },
                splitLine: {
                  show: true,
                  lineStyle: {
                    color: '#ededed',
                    width: 1,
                    type: 'dashed'
                  }
                }
              },
              series: [
                {
                  name: 'NPS(初版)',
                  data: myData[0],
                  type: 'line',
                  stack: '总量',
                  symbolSize: 20,
                  symbol: 'circle',
                  lineStyle: {
                    color: '#4e5598',
                    width: 1,
                    type: 'solid'
                  },
                  itemStyle: {
                    borderWidth: 3,
                    color: '#4e5598'
                  },
                  label: {
                    show: true,
                    position: 'inside',
                    textStyle: {
                      color: '#fff',
                      fontSize: 12
                    }
                  }
                },
                {
                  name: 'NPS(终版)',
                  data: myData[1],
                  type: 'line',
                  stack: '总量',
                  symbol: 'circle',
                  symbolSize: 20,
                  lineStyle: {
                    color: '#b4b331',
                    width: 1,
                    type: 'solid'
                  },
                  itemStyle: {
                    borderWidth: 3,
                    // borderColor: '#b4b331',
                    color: '#b4b331'
                    // normal: {
                    //   color: '#b4b331',
                    //
                    // }
                  },
                  label: {
                    show: true,
                    position: 'inside',
                    textStyle: {
                      color: '#fff',
                      fontSize: 12
                    }
                  }
                }
              ]
            }
            this.chart.setOption(optionData)
          },
          line6: function (id, myData, externalNPS) {
            require('echarts/lib/chart/line')
            this.chart = echarts.init(document.getElementById(id))
            this.chart.clear()
            const optionData = {
              // title: {
              //   subtext: type
              // },
              title: [
                {
                  text: 'External NPS',
                  left: 0,
                  textStyle: {
                    color: '#000',
                    fontWeight: 'normal',
                    fontSize: 14
                  }
                },
                {
                  text: externalNPS,
                  left: 100,
                  textStyle: {
                    color: '#525ca3',
                    fontSize: 16
                  }
                }
              ],
              // tooltip: {
              //   trigger: 'plain',
              //   backgroundColor: '#fff',
              //   borderColor: '#333',
              //   borderWidth: 1,
              //   textStyle: {
              //     color: '#333'
              //   },
              //   formatter (v) {
              //     return 'APP: ' + myData[v[0].dataIndex].appName + '<br>内容类别: ' + myData[v[0].dataIndex].contentTypeName + '<br>文章名称: ' + myData[v[0].dataIndex].contentTitle
              //   }
              // },
              legend: {
                show: false,
                top: '1%',
                right: '10px',
                // x: 'right',
                // y: 'bottom',
                // itemWidth: 10,
                // itemHeight: 10,
                // icon: 'circle',
                selectedMode: false,
                data: ['NPS(初版)', 'NPS(终版)']
              },
              grid: {
                width: '100%',
                top: '50px',
                left: '10PX',
                bottom: '30px'
                // bottom: '20%'
              },
              xAxis: {
                type: 'category',
                data: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
                axisTick: {
                  show: false
                },
                axisLabel: {
                  show: true,
                  color: '#767676',
                  fontSize: 10
                }
              },
              yAxis: {
                show: true,
                axisLine: {
                  show: false
                },
                axisTick: {
                  show: false
                },
                axisLabel: {
                  show: false
                },
                splitLine: {
                  show: true,
                  lineStyle: {
                    color: '#ededed',
                    width: 1,
                    type: 'dashed'
                  }
                }
              },
              series: [
                // {
                //   name: 'NPS(初版)',
                //   data: [120, 200, 150, 80, 70, 110, 130, 150, 80, 70, 110, 130],
                //   type: 'line',
                //   stack: '总量',
                //   symbolSize: 20,
                //   symbol: 'circle',
                //   lineStyle: {
                //     color: '#4e5598',
                //     width: 1,
                //     type: 'solid'
                //   },
                //   itemStyle: {
                //     borderWidth: 3,
                //     color: '#4e5598'
                //   },
                //   label: {
                //     show: true,
                //     position: 'inside',
                //     textStyle: {
                //       color: '#fff',
                //       fontSize: 12
                //     }
                //   }
                // },
                {
                  name: 'NPS(终版)',
                  data: myData,
                  type: 'line',
                  stack: '总量',
                  symbol: 'circle',
                  symbolSize: 20,
                  lineStyle: {
                    color: '#b4b331',
                    width: 1,
                    type: 'solid'
                  },
                  itemStyle: {
                    borderWidth: 3,
                    // borderColor: '#b4b331',
                    color: '#b4b331'
                    // normal: {
                    //   color: '#b4b331',
                    //
                    // }
                  },
                  label: {
                    show: true,
                    position: 'inside',
                    textStyle: {
                      color: '#fff',
                      fontSize: 12
                    }
                  }
                }
              ]
            }
            this.chart.setOption(optionData)
          },
          line7: function (id, myData) {
            require('echarts/lib/chart/bar')
            // require('echarts/lib/component/tooltip')
            // require('echarts/lib/component/title')
            // require('echarts/lib/component/legend')
            // require('echarts/lib/component/grid')
            this.chart = echarts.init(document.getElementById(id))
            this.chart.clear()
            const optionData = {
              // title: {
              //   subtext: type
              // },
              tooltip: {
                trigger: 'axis',
                axisPointer: {
                  type: 'shadow'
                },
                textStyle: {
                  align: 'left'
                }
              },
              grid: {
                width: 'auto',
                top: '60px',
                left: '75px',
                bottom: '10px'
              },
              legend: {
                top: '1%',
                // x: 'right',
                // y: 'bottom',
                itemWidth: 10,
                itemHeight: 10,
                selectedMode: false,
                // icon: 'circle',
                data: ['Target HCP Hit(k)', 'Non-Target HCP Hit(k)']
              },
              xAxis: {
                show: false,
                type: 'value',
                axisLabel: {
                  interval: 0
                },
                textStyle: {
                  color: '#666',
                  fontSize: 10
                },
                axisTick: {
                  interval: 5,
                  length: 5
                }
              },
              yAxis: {
                type: 'category',
                data: myData[0],
                axisTick: {
                  show: false
                },
                axisLine: {
                  lineStyle: {
                    color: '#dddddd',
                    width: 1,
                    type: 'solid'
                  }
                },
                axisLabel: {
                  show: true,
                  color: '#767676',
                  fontSize: 10
                }
              },
              series: [
                {
                  name: 'Target HCP Hit(k)',
                  data: myData[2],
                  type: 'bar',
                  stack: '总量',
                  showBackground: true,
                  backgroundStyle: {
                    color: 'rgba(220, 220, 220, 0.8)'
                  },
                  itemStyle: {
                    normal: {
                      color: '#4e5598',
                      label: {
                        show: true,
                        position: 'inside',
                        textStyle: {
                          color: '#fff'
                          // fontSize: 16
                        },
                        formatter (p) {
                          if (p.value > 0) {
                            return p.value
                          } else {
                            return ''
                          }
                        }
                      }
                    }
                  },
                  barWidth: 12,
                  zlevel: 1
                },
                {
                  name: 'Non-Target HCP Hit(k)',
                  data: myData[1],
                  type: 'bar',
                  stack: '总量',
                  showBackground: true,
                  backgroundStyle: {
                    color: 'rgba(220, 220, 220, 0.8)'
                  },
                  itemStyle: {
                    normal: {
                      color: '#b4b331',
                      label: {
                        show: true,
                        position: 'inside',
                        textStyle: {
                          color: '#fff'
                          // fontSize: 16
                        },
                        formatter (p) {
                          if (p.value > 0) {
                            return p.value
                          } else {
                            return ''
                          }
                        }
                      }
                    }
                  },
                  barWidth: 12,
                  zlevel: 1
                }
              ]
            }
            this.chart.setOption(optionData)
          },
          line8: function (id, myData) {
            require('echarts/lib/chart/bar')
            // require('echarts/lib/component/tooltip')
            // require('echarts/lib/component/title')
            // require('echarts/lib/component/legend')
            // require('echarts/lib/component/grid')
            this.chart = echarts.init(document.getElementById(id))
            this.chart.clear()
            const optionData = {
              // title: {
              //   subtext: type
              // },
              tooltip: {
                trigger: 'axis',
                axisPointer: {
                  type: 'shadow'
                },
                textStyle: {
                  align: 'left'
                },
                formatter (p) {
                  if (p[0].value > 0) {
                    return p[0].name + ': ' + parseFloat(p[0].value * 100).toFixed(0) + '%'
                  } else {
                    return '0'
                  }
                }
              },
              grid: {
                width: 'auto',
                top: '33px',
                left: '75px',
                right: '50px',
                bottom: '10px'
              },
              xAxis: {
                show: false,
                type: 'value',
                axisLabel: {
                  interval: 0
                },
                textStyle: {
                  color: '#666',
                  fontSize: 10
                },
                axisTick: {
                  interval: 5,
                  length: 5
                }
              },
              yAxis: {
                type: 'category',
                data: myData[0],
                axisTick: {
                  show: false
                },
                axisLine: {
                  lineStyle: {
                    color: '#dddddd',
                    width: 1,
                    type: 'solid'
                  }
                },
                axisLabel: {
                  show: true,
                  color: '#767676',
                  fontSize: 10
                }
              },
              series: [{
                data: myData[1],
                type: 'bar',
                showBackground: true,
                backgroundStyle: {
                  color: 'rgba(220, 220, 220, 0.8)'
                },
                itemStyle: {
                  normal: {
                    color: '#4e5598',
                    label: {
                      show: true,
                      position: 'right',
                      textStyle: {
                        color: '#878787'
                        // fontSize: 16
                      },
                      formatter (p) {
                        if (p.value > 0) {
                          return parseFloat(p.value * 100).toFixed(0) + '%'
                        } else {
                          return '0'
                        }
                      }
                    }
                  }
                },
                barWidth: 12,
                zlevel: 1
              }]
            }
            this.chart.setOption(optionData)
          },
          line9: function (id, myData) {
            require('echarts/lib/chart/scatter')
            this.chart = echarts.init(document.getElementById(id))
            this.chart.clear()
            const optionData = {
              // title: {
              //   subtext: type
              // },
              tooltip: {
                trigger: 'item',
                formatter (v) {
                  return 'BU: ' + v.value[3] + '<br>HCP Hit(k): ' + parseFloat(v.value[0] / 1000).toFixed(2) + '<br>Target HCP Hit(k): ' + parseFloat(v.value[1] / 1000).toFixed(2) + '<br>HCP Engage: ' + parseFloat(v.value[2] * 100).toFixed(0) + '%'
                },
                // axisPointer: {
                //   type: 'cross'
                // },
                textStyle: {
                  align: 'left'
                }
              },
              // tooltip: {
              //   trigger: 'plain',
              //   backgroundColor: '#fff',
              //   borderColor: '#333',
              //   borderWidth: 1,
              //   textStyle: {
              //     color: '#333'
              //   },
              //   formatter (v) {
              //     return 'APP: ' + myData[v[0].dataIndex].appName + '<br>内容类别: ' + myData[v[0].dataIndex].contentTypeName + '<br>文章名称: ' + myData[v[0].dataIndex].contentTitle
              //   }
              // },
              grid: {
                width: '84%',
                top: '26px',
                left: '50px',
                bottom: '30px'
              },
              xAxis: {
                splitLine: {
                  lineStyle: {
                    type: 'dashed'
                  }
                },
                axisLine: {
                  lineStyle: {
                    color: '#dddddd',
                    width: 1,
                    type: 'solid'
                  }
                },
                axisLabel: {
                  show: true,
                  color: '#767676',
                  formatter (v) {
                    if (parseFloat(v) > 1000) {
                      return parseFloat(v / 1000).toFixed(2)
                    } else {
                      return v
                    }
                  }
                }
              },
              yAxis: {
                splitLine: {
                  lineStyle: {
                    type: 'dashed'
                  }
                },
                axisLine: {
                  lineStyle: {
                    color: '#dddddd',
                    width: 1,
                    type: 'solid'
                  }
                },
                axisLabel: {
                  show: true,
                  color: '#767676',
                  formatter (v) {
                    if (parseFloat(v) > 1000) {
                      return parseFloat(v / 1000).toFixed(2)
                    } else {
                      return v
                    }
                  }
                }
              },
              series: [{
                symbolSize: function (data) {
                  let num = Math.sqrt(data[2]) * 50
                  if (num < 40) {
                    num = 40
                  }
                  if (num > 100) {
                    num = 100
                  }
                  return num
                },
                data: myData[0],
                itemStyle: {
                  color: '#e0e0a2'
                },
                label: {
                  show: true,
                  position: 'inside',
                  textStyle: {
                    color: '#000',
                    opacity: 0.8
                    // fontSize: 16
                  },
                  formatter (p) {
                    return p.value[3]
                  }
                },
                type: 'scatter'
              }]
            }
            this.chart.setOption(optionData)
          },
          line10: function (id, myData) {
            let xAxisData = []
            let seriesData = []
            for (let i = 0; i < myData.monthHitList.length; i++) {
              xAxisData.push(myData.monthHitList[i].monthStr.toUpperCase())
              seriesData.push(myData.monthHitList[i].count)
            }
            require('echarts/lib/chart/bar')
            require('echarts/lib/component/tooltip')
            require('echarts/lib/component/title')
            require('echarts/lib/component/legend')
            require('echarts/lib/component/grid')
            this.chart = echarts.init(document.getElementById(id))
            this.chart.clear()
            const optionData = {
              // title: {
              //   subtext: type
              // },
              tooltip: {
                trigger: 'axis',
                axisPointer: {
                  type: 'shadow'
                },
                textStyle: {
                  align: 'left'
                }
              },
              // legend: {
              //   top: '1%',
              //   right: '10px',
              //   // x: 'right',
              //   // y: 'bottom',
              //   itemWidth: 10,
              //   itemHeight: 10,
              //   selectedMode: false,
              //   // icon: 'circle',
              //   data: ['DBU', 'PC', 'CV&EP', 'Medical', 'SC', 'Vaccine']
              // },
              grid: {
                width: 'auto',
                top: '20px',
                left: '10PX',
                right: '10px',
                bottom: '30px'
              },
              xAxis: {
                type: 'category',
                data: xAxisData,
                axisTick: {
                  show: false
                },
                axisLine: {
                  lineStyle: {
                    color: '#dddddd',
                    width: 1,
                    type: 'solid'
                  }
                },
                axisLabel: {
                  show: true,
                  color: '#767676',
                  fontSize: 10
                }
              },
              yAxis: {
                show: true,
                axisLine: {
                  show: false
                },
                axisTick: {
                  show: false
                },
                axisLabel: {
                  show: false
                },
                splitLine: {
                  show: true,
                  lineStyle: {
                    color: '#ededed',
                    width: 1,
                    type: 'dashed'
                  }
                }
              },
              series: [
                {
                  data: seriesData,
                  type: 'bar',
                  itemStyle: {
                    normal: {
                      // 每根柱子颜色设置
                      color: '#515696'
                    }
                  },
                  barWidth: 12
                }
              ]
            }
            this.chart.setOption(optionData)
          },
          line11: function (id, myData) {
            let xAxisData = []
            let seriesData = []
            for (let i = 0; i < myData.monthHitList.length; i++) {
              xAxisData.push(myData.monthHitList[i].monthStr.toUpperCase())
              seriesData.push(myData.monthHitList[i].count)
            }
            require('echarts/lib/chart/bar')
            require('echarts/lib/component/tooltip')
            require('echarts/lib/component/title')
            require('echarts/lib/component/legend')
            require('echarts/lib/component/grid')
            this.chart = echarts.init(document.getElementById(id))
            this.chart.clear()
            const optionData = {
              // title: {
              //   subtext: type
              // },
              tooltip: {
                trigger: 'axis',
                axisPointer: {
                  type: 'shadow'
                },
                textStyle: {
                  align: 'left'
                }
              },
              grid: {
                width: 'auto',
                top: '20px',
                left: '10PX',
                right: '10px',
                bottom: '30px'
              },
              xAxis: {
                type: 'category',
                data: xAxisData,
                axisTick: {
                  show: false
                },
                axisLine: {
                  lineStyle: {
                    color: '#dddddd',
                    width: 1,
                    type: 'solid'
                  }
                },
                axisLabel: {
                  show: true,
                  color: '#767676',
                  fontSize: 10
                }
              },
              yAxis: {
                show: true,
                axisLine: {
                  show: false
                },
                axisTick: {
                  show: false
                },
                axisLabel: {
                  show: false
                },
                splitLine: {
                  show: true,
                  lineStyle: {
                    color: '#ededed',
                    width: 1,
                    type: 'dashed'
                  }
                }
              },
              series: [
                {
                  data: seriesData,
                  type: 'bar',
                  itemStyle: {
                    normal: {
                      // 每根柱子颜色设置
                      color: '#bda773'
                    }
                  },
                  barWidth: 12
                }
              ]
            }
            this.chart.setOption(optionData)
          }
        }
      }
    }
  })
}

export default {
  install
}



// WEBPACK FOOTER //
// ./src/assets/js/myCharts.js